import '../../css/style.scss';
import { UIWHeaderController } from '../ui_html/header/UIWHeaderController.ts';
import { UISidebarController } from '../ui_html/sidebar/UISidebarController.ts';
import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { UISingletonScrollController } from '../../../shared/scripts/ui_scroll_controller/UISingletonScrollController.ts';
import { UIPatchNotes } from '../../../shared/scripts/patch_notes/UIPatchNotes.ts';
import { EntrySingletonPageShared } from '../../EntrySingletonPageShared.ts';
void init();
async function init() {
    await EntryShared.initializeEntry();
    const sidebar = document.getElementById('patch_note_sidebar');
    new UIPatchNotes(sidebar);
    const headerController = new UIWHeaderController();
    new UISidebarController();
    new UISingletonScrollController();
    EntryShared.initializeAudio();
    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController);
    EntryShared.sendPageVisitAnalyticEvent();
}
